const loginStyles = () => ({});

export default loginStyles;
